/**
 * Enum for a type of option. For each type the emitted filter value could
 * either stand for a field name or a ISO date string.
 */
export enum OptionType {
  FIELD = 0, // Option should allow comparing against another field.
  SPECIFIC_DATE = 1, // Option should allow comparing against a date value.
}
